import { render, staticRenderFns } from "./ElementScalePartTableColumn.vue?vue&type=template&id=10b7f76a&scoped=true"
import script from "./ElementScalePartTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScalePartTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementScalePartTableColumn.vue?vue&type=style&index=0&id=10b7f76a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b7f76a",
  null
  
)

export default component.exports